export default __webpack_public_path__ + "static/media/mn_logo.72698423.png";